import { createApp } from 'vue';
import axios from 'axios';

export default class RulingList {
  constructor() {
    this.setup();
  }

  setup() {
    const componentClass = '.ruling-list';
    const component = document.querySelector(componentClass);

    if (component) {
      const rulingList = {
        data() {
          return {
            initialized: false,
            rulings: [],
            years: [],
            year: 0,
            courts: [],
            court: 0,
            subjects: [],
            subject: 0,
            sort: 'desc',
            total: 0,
            page: 1,
            hasMore: false
          }
        },
        mounted() {
          this.fetchRulings();
          this.fetchLists();
          this.initialized = true;
        },
        methods: {
          fetchRulings() {
            this._fetchRulings(this.page);
          },
          filterRulings() {
            this.rulings = [];
            this.page = 1;
            this._fetchRulings(1);
          },
          sortRulings() {
            this.rulings = [];
            this.page = 1;
            this._fetchRulings(1);
          },
          _fetchRulings(page) {
            return axios.get('/api/rulings/list', {
              params: {
                sort: this.sort,
                year: this.year,
                court: this.court,
                subject: this.subject,
                page: page
              }
            })
              .then(response => {
                this.rulings = [...this.rulings, ...response.data.result];
                this.total = response.data.total;
                this.hasMore = response.data.hasMore;
              })
              .catch((error) => {
                this.rulings = [];
                this.total = 0;
                this.hasMore = false;
                console.log(error);
              });
          },
          nextPage() {
            this.page++;
            this.fetchRulings();
          },
          fetchLists() {
            axios.get('/api/rulings/years')
              .then(response => {
                this.years = response.data;
              });
            axios.get('/api/rulings/courts')
              .then(response => {
                this.courts = response.data;
              });
            axios.get('/api/rulings/subjects')
              .then(response => {
                this.subjects = response.data;
              });
          }
        }
      };

      this._component = createApp(rulingList).mount(componentClass);
    }
  }
}
